/**
 * What an approval covers, one entry per action: a plain label (the action's own label, or its app
 * and action names) and the values Pieve will send, as `key: value` lines.
 */
const toApprovalActionLines = (actions) => {
  return (Array.isArray(actions) ? actions : [])
    .map((action, index) => {
      if (typeof action === 'string') {
        return { key: `${index}`, label: action.trim(), values: [] };
      }
      const label = String(action?.label || action?.title || [action?.appName, action?.actionName].filter(Boolean).join(': ')).trim();
      const args = action?.args && typeof action.args === 'object' ? action.args : {};
      const values = Object.entries(args).map(([name, value]) => `${name}: ${typeof value === 'string' ? value : JSON.stringify(value)}`);
      return { key: `${index}-${label}`, label, values };
    })
    .filter((line) => line.label);
};

export default toApprovalActionLines;
